<template>
    <div>
        <div class="flex flex-wrap">
            <div
                v-for="(image, index) in thumbsToUse"
                :key="index"
                class="p-1 cursor-pointer"
                @click="openLightbox(index)"
            >
                <img
                    :src="image"
                    alt="Image"
                    class="object-cover"
                    loading="lazy"
                />
            </div>
        </div>

        <div
            v-if="showLightbox"
            class="fixed top-0 left-0 right-0 bottom-0 bg-kvpBlack bg-opacity-80 z-50 flex flex-col md:flex-row items-center justify-center w-full h-full"
            @click="closeLightbox"
            @touchend="onTouchEnd"
            @touchmove="onTouchMove"
            @touchstart="onTouchStart"
        >
            <div v-if="currentImage > 0" class="mb-4 md:mr-4 md:mb-0">
                <button
                    class="p-2 rounded-lg hover:"
                    @click.stop="previousImage"
                >
                    <svg class="h-10 w-10" fill="none" stroke="white" viewBox="0 0 24 24">
                        <path
                            d="M15 19l-7-7 7-7"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </svg>
                </button>
            </div>
            <img
                :src="imagesToUse[currentImage]"
                :style="{ transform: `translateX(${translateX}px)` }"
                alt="Lightbox Image"
                class="w-auto h-auto max-w-full max-h-full md:p-24"
                loading="lazy"
            />
            <div v-if="currentImage < imagesToUse.length - 1" class="mt-4 md:ml-4 md:mt-0">
                <button
                    class="p-2 rounded-lg"
                    @click.stop="nextImage"
                >
                    <svg class="h-10 w-10" fill="none" stroke="white" viewBox="0 0 24 24">
                        <path
                            d="M9 5l7 7-7 7"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </svg>
                </button>
            </div>
            <button
                class="absolute top-0 right-0 mt-2 mr-2"
                @click="closeLightbox"
            >
                <svg class="h-10 w-10" fill="none" stroke="white" viewBox="0 0 24 24">
                    <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                </svg>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "Lightbox-gallery",
    data() {
        return {
            showLightbox: false,
            currentImage: 0,
            imagesToUse: [],
            thumbsToUse: [],
            touchStartX: 0,
            touchMoveX: 0,
            translateX: 0,
        };
    },
    props: {
        images: {
            type: Array,
            required: false,
            default: []
        },
        folder: {
            type: String,
            required: false,
            default: null
        },
        max_images_thumbs: {
            type: Number,
            required: false,
            default: Infinity
        }
    },
    methods: {
        onTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.touchMoveX = 0;
        },
        onTouchMove(event) {
            this.touchMoveX = event.touches[0].clientX - this.touchStartX;
        },
        onTouchEnd() {
            if (Math.abs(this.touchMoveX) > 50) { // Adjust this threshold as needed
                if (this.touchMoveX > 0) {
                    this.previousImage();
                } else {
                    this.nextImage();
                }
            }
            this.touchStartX = 0;
            this.touchMoveX = 0;
        },
        openLightbox(index) {
            this.showLightbox = true;
            this.currentImage = index;
        },
        closeLightbox() {
            this.showLightbox = false;
        },
        previousImage() {
            if (this.currentImage > 0) {
                this.currentImage--;
            }

            this.preload();
        },
        nextImage() {
            // Increase the index by 1,
            if (this.currentImage < this.imagesToUse.length - 1) {
                this.currentImage++;
            }

            this.preload();
        },
        async preload() {
            // Load the next and previous images
            if (this.currentImage < this.imagesToUse.length - 1) {
                await this.loadImage(this.imagesToUse[this.currentImage + 1]);
            }

            if (this.currentImage > 0) {
                await this.loadImage(this.imagesToUse[this.currentImage - 1]);
            }
        },
        async loadImage(src) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;
                img.onload = () => resolve();
                img.onerror = () => reject();
            });
        },
        async getImages(folder) {
            let url = route('admin.bestanden.documenten.getFiles');
            let response = await axios.get(url, {
                params: {
                    path: folder
                }
            });

            let images = [];

            let data = await response.data;
            data.forEach((item) => {
                images.push('/public/storage/' + item);
            });

            return images;
        },
    },
    async mounted() {
        if (this.folder !== null) {
            this.imagesToUse = await this.getImages(this.folder + "/big");
            this.thumbsToUse = await this.getImages(this.folder + "/small");
        } else {
            this.imagesToUse = this.images;
            this.thumbsToUse = this.images;
        }

        if (this.max_images_thumbs < this.thumbsToUse.length) {
            this.thumbsToUse = this.thumbsToUse.slice(0, this.max_images_thumbs);
        }

        this.preload().then(r => {
        });
    }
}

</script>

<style scoped>

.object-cover {
    object-fit: cover;
    width: 100px;
    height: 100px;
}

.object-contain {
    object-fit: contain;
    max-width: 1000px;
    max-height: 1000px;
}

</style>
